import React, { Component } from 'react';

// Components
import { PageSection } from '../PageSection';

export class AppPreview extends Component {
    render() {
        return (
            <PageSection sectionId="app-preview">
                <div className="inner">
                    <img id="app-preview-corner" src="./images/app-preview/app-preview-corner.png" alt="" />
                    <img id="app-preview-phone" src="./images/app-preview/app-preview-phone-with-screen.png" alt="" />
                    <img id="app-preview-phone-small" src="./images/app-preview/app-preview-phone-with-screen-smaller.png" alt="" />
                </div>

                {this.props.children}
            </PageSection>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/sections/AppPreview.jsx